/**
 * ContentListBlockRenderer renders a content_list block using the
 * ContentListCard component from @strivelabs/ui-blocks.
 *
 * Used in both chat and report contexts via dispatchBlock().
 */

import { ContentListCard } from '@strivelabs/ui-blocks';
import type { UIBlock } from '@/types/ui-blocks';

export interface ContentListBlockRendererProps {
  block: UIBlock;
}

export function ContentListBlockRenderer({ block }: ContentListBlockRendererProps) {
  if (block.type !== 'content_list') return null;

  const { content } = block;

  return (
    <ContentListCard
      title={content.title}
      titleSize={content.title_size}
      items={content.items.map((item) => ({
        ...item,
        // Actions from backend don't have onClick — render as non-interactive labels
        actions: item.actions?.map((a) => ({
          label: a.label,
          variant: a.variant,
          onClick: () => {},
        })),
      }))}
      showSteps={content.show_steps}
    />
  );
}
